module.exports = __webpack_public_path__ + "static/media/Food5.6d917822.jpg";